import SearchBar from '../SearchBar/SearchBar';
import classes from './HeroSection.module.scss';
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';

const HeroSection = ({ compact, hideSearchBar }) => {

    const location = useLocation();
    const isMobile = useMediaQuery('(max-width:768px)');

    let bgImage;
    let imgHeight;
    let outerHeroDivPad = '119px';
    let pageName;
    let headerText = false
    let searchbar = true
    let justifyContent = "space-between";

    switch (location.pathname) {
        case '/auction':
            bgImage = require('../../media/heroImgs/AuctionBG.png');
            imgHeight = compact ? "150px" : "236px"
            justifyContent = "center"
            break;
        case '/inspection':
            bgImage = require('../../media/heroImgs/Inspection&PurchasesBG.png');
            imgHeight = compact ? "200px" : "402px"
            justifyContent = "center"
            searchbar = false
            break;
        case '/purchase':
            bgImage = require('../../media/heroImgs/Inspection&PurchasesBG.png');
            imgHeight = compact ? "200px" : "402px"
            justifyContent = "center"
            searchbar = false
            break;
        case '/management':
            bgImage = require('../../media/heroImgs/Inspection&PurchasesBG.png');
            imgHeight = compact ? "200px" : "402px"
            justifyContent = "center"
            searchbar = false
            break; 
        case '/profile':
            bgImage = require('../../media/heroImgs/Inspection&PurchasesBG.png');
            imgHeight = compact ? "120px" : "200px"
            justifyContent = "center"
            searchbar = false
            break;    
        case '/detail':
            bgImage = require('../../media/heroImgs/AuctionBG.png');
            imgHeight = compact ? "120px" : "200px"
            justifyContent = "center"
            searchbar = false
            break;
        case '/favorites':
            bgImage = require('../../media/heroImgs/AuctionBG.png');
            imgHeight = compact ? "120px" : "200px"
            justifyContent = "center"
            searchbar = false
            break;
        case '/': 
            bgImage = require('../../media/heroImgs/Dashboard.png');
            outerHeroDivPad = "0px"
            imgHeight = compact ? "250px" : "400px"
            headerText = true;
            pageName = "homePage";
            break;
        default:
            bgImage = require('../../media/heroImgs/AuctionBG.png');
            imgHeight = compact ? "120px" : "200px"
            justifyContent = "center"
            searchbar = false
            break;
    }

    const heroClasses = `${pageName ? pageName : ''} ${classes.OuterHeroDiv} ${compact ? classes.compact : ''}`;
    
    // On mobile, hide search bar if filter is open
    const shouldShowSearchBar = searchbar && !(isMobile && hideSearchBar);

    return (
        <section className={heroClasses} style={{ paddingTop: outerHeroDivPad }} >
            <img className={classes.BgImg} src={bgImage} alt='IMG' style={{minHeight: imgHeight}} />
            <div className={classes.InnerHeroDiv} style= {{justifyContent: justifyContent}}>
                {headerText && (<div className={classes.textContainer}>
                <h1>Your JDM Journey Starts Here</h1>
                <p>Search, Inspect, and Buy with Confidence!</p>
                </div>
                )}
                {shouldShowSearchBar && <SearchBar />}
            </div>
        </section>
    )
}

export default HeroSection;